import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { api } from "@/services/api";
import ShimmerEffect from "@/components/Shimmer";
import { QrCode } from "@/Icons/img/index";
import { Context } from "@/contexts/AuthContext";

import { Container } from "./styles";

export const PriviteHome = () => {
	const { handleLogout } = useContext(Context);
	const [data, setData] = useState(null);
	const [user, setUser] = useState(null);
	const [load, setLoad] = useState(false);
	const loadElements = [];

	for (let index = 0; index < 2; index++) {
		loadElements.push(index);
	}

	useEffect(() => {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		const loadData = () => {
			setLoad(true);

			api.get("consumer/coupons", {
				cancelToken: source.token,
				params: { type: "coupons" },
			})
				.then((res) => {
					setData(res?.data);
				})
				.catch((error) => {
					const { response } = error;
					if (response?.status === 500) {
						if (response?.data?.message === "Unauthenticated.") {
							alert(
								"Você não tem um token de acesso valido. Por favor faça login novamente.",
							);
							handleLogout(`${process.env.PUBLIC_URL}/login/consumer`);
						}
					}
					console.warn({ endPoint: "consumer/coupons", error });
				})
				.finally(() => setLoad(false));
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const profile = localStorage.getItem("@profile");
		setUser(JSON.parse(profile));
	}, []);

	return (
		<Container>
			<header>
				<img
					loading='lazy'
					className='img-responsive d-none d-lg-block'
					src={require("@/assets/img/cao-e-gato-consumidor.png").default}
					alt='cao e gato'
				/>
			</header>
			<div className='wellcome'>
				<p className='helloUser'>
					Olá <strong>{user?.firstname}</strong>,{" "}
					<br className='d-none d-lg-block' /> selecione o cupom de
					desconto de:
				</p>
				<ul className='list-pets'>
					{data?.coupons.map((cupom, index) => (
						<li key={index}>
							<Link
								style={{
									pointerEvents:
										cupom.validated === "Cupom Utilizado"
											? "none"
											: "",
								}}
								to={{
									pathname: `${process.env.PUBLIC_URL}/qrcode`,
									state: { data: data.coupons[index] },
								}}>
								<div className='block'>
									<div className='qrCode'>
										<QrCode
											className='qrCode__svg'
											width={60}
											height={60}
										/>
										<p className='qrCode__name'>
											{cupom.pet}
										</p>
									</div>
									<p className='block__link'>
										Visualizar cupom{" "}
									</p>
									<p className='block__validated'>
										{cupom.validated ===
											"Cupom Utilizado" && "(Utilizado)"}
									</p>
								</div>
							</Link>
						</li>
					))}
					{load &&
						loadElements.map((_, index) => (
							<li key={index}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
									}}>
									<ShimmerEffect
										width={80}
										height={80}
										border={2}
										style={{ marginBottom: "10px" }}
									/>
									<ShimmerEffect width={120} height={20} />
								</div>
							</li>
						))}
					{data === null && load === false && (
						<li className='no-cupom'>
							No momento não há cupons disponíveis.
						</li>
					)}
				</ul>
			</div>
		</Container>
	);
};

export default PriviteHome;
